import styled, { keyframes, createGlobalStyle } from 'styled-components';

export const GlobalStyleSucesso = createGlobalStyle`
  #root {
    margin: 0 !important;
    padding: 0 !important;
    height: 100vh !important;
    width: 100vw !important;
    overflow: hidden;
  }
`;

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const SucessoContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  animation: ${fadeInUp} 0.4s ease both;
`;

// Esta div ocupa todo o espaço central e centraliza o conteúdo
export const MainContent = styled.div`
  flex: 1; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconWrapper = styled.div`
  width: 90px;
  height: 90px;
  margin-bottom: 32px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled.h1`
  font-size: 42px;
  font-weight: 800;
  color: #4A6B53;
  margin: 0;
  line-height: 1.1;
  letter-spacing: -1px;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #68717A;
  margin-top: 16px;
`;

// Rodapé que isola o botão na parte inferior
export const FooterAction = styled.div`
  width: 100%;
  padding: 24px 32px;
  display: flex;
  justify-content: flex-end; /* Alinha o botão à direita */
  background-color: #fff;
`;

export const BackButton = styled.button`
  padding: 10px 24px;
  margin-right: 50px;
  border: 1px solid #D8DCDE;
  border-radius: 4px;
  background: #fff;
  color: #2F3941;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #F8F9F9;
    border-color: #C2C8CC;
  }
`;